import 'regenerator-runtime/runtime';
import './react-dom-polyfill';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import env from 'src/env';
import { GoogleMapsProvider } from 'src/applicationproviders';
import { BrowserStorageProvider } from 'src/hooks/use-browser-storage';
import store from 'src/store';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import App from './App';
import { ConfirmationProvider, ErrorHandlerProvider } from './hooks';
import './index.scss';
import { sanitizeRequest, sanitizeResponse } from 'src/util/networksanitizer';
import { CanonicalFieldFetcherProvider } from 'src/applicationproviders/CanonicalFieldFetcherProvider';
import { apiAxios } from 'src/util';
import { Auth0Provider } from 'src/applicationproviders';
import { MuiThemeProvider } from 'src/applicationproviders/MuiThemeProvider';

if (env.LOGROCKET_APPID) {
  LogRocket.init(env.LOGROCKET_APPID, {
    network: {
      requestSanitizer: (request) => {
        request = sanitizeRequest(request);
        if (request?.url?.toLowerCase()?.indexOf('visualstudio') !== -1) {
          request = null;
        }
        return request;
      },
      responseSanitizer: sanitizeResponse,
    },
  });
  setupLogRocketReact(LogRocket);
  LogRocket.getSessionURL((sessionURL) => {
    apiAxios.defaults.headers.common['X-LogRocket-URL'] = sessionURL;
  });
}

console.log(
  `Build #: %c${import.meta.env.VITE_BUILD_NUMBER ?? 'LOCAL'}`,
  'color: #ffffff; font-weight: bold; background: #00acc4; border-radius: 13px; padding: 2px 10px;',
);

const mapsApiKey = 'AIzaSyBfm1-zWTPuNPLYWXWbRQPgs-tyguqkEiE';
const mapsLibraries = ['places'];

const elem = document.getElementById('root');
const root = ReactDOM.createRoot(elem);

const render = (Component) => {
  root.render(
    <Provider store={store}>
      <BrowserStorageProvider>
        <Auth0Provider>
          <MuiThemeProvider>
            <CssBaseline />
            <SnackbarProvider
              maxSnack={5}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <ErrorHandlerProvider>
                <ConfirmationProvider>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <GoogleMapsProvider
                      googleMapsApiKey={mapsApiKey}
                      language='en'
                      libraries={mapsLibraries}
                    >
                      <BrowserRouter>
                        <QueryParamProvider adapter={ReactRouter6Adapter}>
                          <CanonicalFieldFetcherProvider>
                            <Component />
                          </CanonicalFieldFetcherProvider>
                        </QueryParamProvider>
                      </BrowserRouter>
                    </GoogleMapsProvider>
                  </LocalizationProvider>
                </ConfirmationProvider>
              </ErrorHandlerProvider>
            </SnackbarProvider>
          </MuiThemeProvider>
        </Auth0Provider>
      </BrowserStorageProvider>
    </Provider>,
  );
};

if (elem) render(App);

// Vite HMR
if (import.meta.hot) {
  import.meta.hot.accept('./App', (newModule) => {
    if (newModule) {
      console.clear();
      render(newModule.default);
    }
  });
}
